/**
 * Get the display name for a lead, falling back to email or 'Unknown'
 */
export function getLeadDisplayName(lead, fallback = 'Unknown') {
    const rawName = lead.FullName || [lead.FirstName, lead.LastName].filter(Boolean).join(' ');
    return (rawName && rawName.trim().length > 0) ? rawName : (lead.Email || fallback);
}
/**
 * Determine if email should be shown as a separate line (when it differs from display name)
 */
export function shouldShowEmailLine(lead, displayName) {
    return !!lead.Email && lead.Email !== displayName;
}
